import { Viewer, XKTLoaderPlugin } from "@xeokit/xeokit-sdk";
import {
  ActionType,
  AddModel,
  ClearModels,
  SetLoaderPlugin,
  SetModels,
  SetViewer,
  SetViewerConfig,
  XktActions,
} from "./Actions";
import { XktState } from "./XktState";
import Model from "../../Models/Model";
import ViewerConfig from "@/Models/ViewerConfig";

const viewerReducer = (state: XktState, action: XktActions): XktState => {
  switch (action.type) {
    case ActionType.SetModels:
      return { ...state, models: action.models };
    case ActionType.ClearModels:
      return { ...state, models: [] };
    case ActionType.AddModel:
      return { ...state, models: [...state.models, action.model] };
    case ActionType.SetViewer:
      return { ...state, viewer: action.viewer };
    case ActionType.SetLoaderPlugin:
      return { ...state, loaderPlugin: action.loaderPlugin };
    case ActionType.SetViewerConfig:
      return { ...state, viewerConfig: action.viewerConfig };
    default:
      return state;
  }
};

export const setModels = (models: Model[]): SetModels => ({
  type: ActionType.SetModels,
  models,
});

export const clearModels = (): ClearModels => ({
  type: ActionType.ClearModels,
});

export const addModel = (model: Model): AddModel => ({
  type: ActionType.AddModel,
  model,
});

export const setViewer = (viewer: Viewer | null): SetViewer => ({
  type: ActionType.SetViewer,
  viewer,
});

export const setLoaderPlugin = (
  loaderPlugin: XKTLoaderPlugin
): SetLoaderPlugin => ({
  type: ActionType.SetLoaderPlugin,
  loaderPlugin,
});
export const setViewerConfig = (viewerConfig: ViewerConfig): SetViewerConfig => ({
  type: ActionType.SetViewerConfig,
  viewerConfig,
});

export default viewerReducer;
